import React from "react";
import type { VariantType } from "@shared/graphql.types";
import { space } from "theme/themeConfig";
import type { ChakraProps } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { Rating } from "components/Rating";

type ProductCardRatingProps = ChakraProps & {
  variant: VariantType;
};

export const ProductCardRating: React.FC<ProductCardRatingProps> = ({
  variant,
  ...chakraProps
}) => {
  const { review, availability } = variant;
  const { stars: reviewStars, count: reviewCount } = review || {};
  const outOfStock = availability?.status === "outofstock";
  const isComingSoon = availability?.label?.toLowerCase() === "coming soon";
  const showOutOfStock = outOfStock && !isComingSoon;

  return reviewCount && reviewStars ? (
    <Box mb={-1} {...chakraProps}>
      <Rating
        outOfStock={showOutOfStock}
        reviewCount={reviewCount}
        reviewStars={reviewStars}
      />
    </Box>
  ) : (
    <Box height={space[1]} mb={-1} />
  );
};
